var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffffff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.89,59.68l.34-.34c12.01-12.01,12.01-31.66,0-43.67l-2.77-2.77C44.45.89,24.8.89,12.79,12.9l-.34.34C.44,25.25.44,44.9,12.45,56.91l2.77,2.77c12.01,12.01,31.66,12.01,43.67,0ZM12.9,24.39c2.36-1.49,5.15-2.36,8.14-2.36,7.12,0,13.09,4.87,14.8,11.46,1.71-6.59,7.68-11.46,14.8-11.46,3,0,5.78.87,8.14,2.36v23.8c-2.36-1.49-5.15-2.36-8.14-2.36-7.12,0-13.09,4.87-14.8,11.46-1.71-6.59-7.68-11.46-14.8-11.46-3,0-5.78.87-8.14,2.36v-23.8Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7e3973b5adff51183248cb4fdff32ea4.svg";
export { ForwardRef as ReactComponent };